import React, { useState, useEffect } from "react";
import axios from "../../services/axios";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import useAuth from "../../hooks/useAuth";
import { IoPencil } from "react-icons/io5";
import { convertLanguageToField } from "../../utils/functions";
import { useSelector, useDispatch } from "react-redux";
import {
  setVisible,
  setDescription,
  setTitle,
} from "../../store/slices/customCategory";
import {
  setVisible as setChallengeModal,
  setDesafio,
  setIdDesafio,
  setQuemFaz,
  setTempo,
} from "../../store/slices/customSoloChallenge";
import { useNavigate } from "react-router";

import Header, {
  NoHeaderScroll,
  BackHeaderLeft,
} from "../../components/navigation/header";
import Spinner from "../../components/utils/spinner";
import { SoloChallenge } from "../../components/solo/categoryCard";
import { AddCategory } from "../../components/customChallenges/cards";
import AddCategorySolo from "../../components/solo/modals/addCategory";
import AddChallengeSolo from "../../components/solo/modals/addChallenge";

function HeaderCenter() {
  const title = useSelector((state) => state.customCategory.title);
  return <h1 className="text-xl font-extrabold">{title}</h1>;
}

export default function SoloPlayerChallenges() {
  const { i18n } = useTranslation();
  const { category } = useLocation().state;

  const { user } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const title = convertLanguageToField(i18n.language, "title");
  const [challenges, setChallenges] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(setTitle(category.custom ? category.title : category[title]));
    dispatch(setDescription(category.description));
    fetchChallenges();
  }, []);

  const fetchChallenges = () => {
    setLoading(true);
    axios
      .get(
        `/solo/customChallenges?id_usuario=${user.id_usuario}&id_categoria=${
          category.custom
            ? category.id_categorias_solo_usuario
            : category.id_cat_solo
        }&custom=${category.custom ? "1" : ""}`
      )
      .then((response) => {
        setChallenges(response.data);
      })
      .catch(console.log)
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClick = (challenge) => {
    dispatch(setChallengeModal(true));
    dispatch(setDesafio(challenge.desafio));
    dispatch(setIdDesafio(challenge.id_desafio_solo));
    dispatch(setQuemFaz(challenge.quemFaz));
    dispatch(setTempo(challenge.duracao));
  };

  const handleAddClick = () => {
    dispatch(setChallengeModal(true));
  };

  const handleEditCategory = () => {
    dispatch(setVisible(true));
  };

  const handleUpdateCategory = ({ title, description }) => {
    if (title && description) {
      axios.put("/solo/customCategory", {
        id_categoria: category.id_categorias_solo_usuario,
        title: title,
        description: description,
      });
    }
  };

  const handleSaveChallenge = (form) => {
    axios
      .post("/solo/customChallenge", {
        id_usuario: user.id_usuario,
        id_categoria: category.custom
          ? category.id_categorias_solo_usuario
          : category.id_cat_solo,
        id_desafio_solo: form.id_desafio,
        desafio: form.desafio,
        quemFaz: form.quemFaz,
        duracao: form.tempo,
        lingua: i18n.language,
        categoria_padrao: category.custom ? 0 : 1,
      })
      .then(() => {
        fetchChallenges();
      })
      .catch(console.log);
  };

  const handleRemoveChallenge = (id) => {
    axios
      .post("/solo/removeChallenge", {
        id_desafio_solo: id,
      })
      .then(() => {
        fetchChallenges();
      });
  };

  const handleDelete = () => {
    axios
      .post("/solo/removeCategory", {
        id_categoria: category.id_categorias_solo_usuario,
      })
      .then(() => {
        navigate("/solo/player-categories");
      });
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header
        HeaderLeft={BackHeaderLeft}
        HeaderCenter={HeaderCenter}
        HeaderRight={
          category.custom
            ? () => {
                return (
                  <button
                    className="touchable-opacity"
                    onClick={handleEditCategory}
                  >
                    <IoPencil size={28} />
                  </button>
                );
              }
            : undefined
        }
      />
      <NoHeaderScroll className="ps-5 pe-5">
        {loading ? (
          <div className="flex justify-center">
            <Spinner />
          </div>
        ) : (
          <div>
            {challenges.map((challenge, index) => (
              <SoloChallenge
                key={`challenge-${index}`}
                index={index}
                challenge={challenge}
                onClick={handleClick}
              />
            ))}
          </div>
        )}
        <div className="absolute bottom-10 right-5">
          <AddCategory onClick={handleAddClick} index={challenges.length} />
        </div>
        <AddCategorySolo
          edit={true}
          onSave={handleUpdateCategory}
          onDelete={handleDelete}
        />
        <AddChallengeSolo
          onSave={handleSaveChallenge}
          onRemove={handleRemoveChallenge}
        />
      </NoHeaderScroll>
    </div>
  );
}
